import { Auth0Provider } from "@auth0/auth0-react";
import { ComponentType, FC } from "react";
import { useAppSelector } from "store";
import { selectAuth0 } from "store/slices/user.store";

interface LoginRouteProps {
  component: ComponentType<any>;
}

export const LoginRoute: FC<LoginRouteProps> = ({ component: Component }) => {
  const { domain, clientId, audience } = useAppSelector(selectAuth0);

  return (
    <Auth0Provider
      domain={domain!}
      clientId={clientId!}
      redirectUri={`${window.location.origin}/login/auth0callback/`}
      audience={audience!}
      scope="read:current_user update:current_user_metadata"
      useRefreshTokens
      cacheLocation="localstorage"
    >
      <Component />
    </Auth0Provider>
  );
};
